<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-toc" id="table-of-contents">
<div class="heading heading-with-title heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title case-mixed">Contents</h1>
</div>
</div>
</div>
</div>
<div class="toc-contents text">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/foreword"><span class="item-title-text">Foreword</span></a></p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/prologue"><span class="item-title-text">Prologue</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">1. </span><a href="#/chapter001"><span class="item-title-text">Dream Awake</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">2. </span><a href="#/chapter002"><span class="item-title-text">Scarab</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">3. </span><span href="#/chapter003" title="Link target outside of Sample"><span class="item-title-text">Worldeater</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">4. </span><span href="#/chapter004" title="Link target outside of Sample"><span class="item-title-text">Masquerade</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">5. </span><span href="#/chapter005" title="Link target outside of Sample"><span class="item-title-text">Aspire</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">6. </span><span href="#/chapter006" title="Link target outside of Sample"><span class="item-title-text">Citizen</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">7. </span><span href="#/chapter007" title="Link target outside of Sample"><span class="item-title-text">Refuge</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">8. </span><span href="#/chapter008" title="Link target outside of Sample"><span class="item-title-text">Sleepless</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">9. </span><span href="#/chapter009" title="Link target outside of Sample"><span class="item-title-text">Scarabs II</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">10. </span><span href="#/chapter010" title="Link target outside of Sample"><span class="item-title-text">Leech</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">11. </span><span href="#/chapter011" title="Link target outside of Sample"><span class="item-title-text">Colourwave</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">12. </span><span href="#/chapter012" title="Link target outside of Sample"><span class="item-title-text">Vultures</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">13. </span><span href="#/chapter013" title="Link target outside of Sample"><span class="item-title-text">Quantum Flux</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/forhumansfordemons" title="Link target outside of Sample"><span class="item-title-text">For Humans, For Demons:</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/prologue2" title="Link target outside of Sample"><span class="item-title-text">Prologue</span></span></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/acknowledgments" title="Link target outside of Sample"><span class="item-title-text">Acknowledgments</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/arequest" title="Link target outside of Sample"><span class="item-title-text">A Request…</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/abouttheauthor" title="Link target outside of Sample"><span class="item-title-text">About the Author</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/theparliamenthouse" title="Link target outside of Sample"><span class="item-title-text">The Parliament House</span></span></p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2e3ad870